import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useResolveRoute } from '@mews/routing';
import { ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { RouteName } from '@mews-commander/enums';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { Breadcrumbs } from '@mews-commander/modules/src/components';
import { HeadingAction, ModalHeader } from '@mews-commander/modules/src/legacy/React';
import { TabsConfig, WithBreadcrumbs } from '@mews-commander/modules/src/modules/modalManager';

interface EnterpriseProfileRoleProps extends WithBreadcrumbs {
    actions?: HeadingAction[];
    tabsConfig?: TabsConfig;
}

export const PropertyLayoutWrapper: React.FC<React.PropsWithChildren<EnterpriseProfileRoleProps>> = ({
    breadcrumbs,
    children,
    actions,
    tabsConfig,
}) => {
    const enterpriseId = useCurrentEnterpriseId();
    const { name: enterpriseName } = useCurrentEnterprise();
    const resolveRoute = useResolveRoute();
    const enterpriseUrl = resolveRoute(RouteName.EnterpriseDetail, { enterpriseId });

    const finalBreadcrumbs: Breadcrumbs = [{ text: enterpriseName, url: enterpriseUrl }, ...breadcrumbs];

    return (
        <ModalWrapper>
            <ModalHeader breadcrumbs={finalBreadcrumbs} actions={actions} tabsConfig={tabsConfig} />
            <NewModalBodyWrapper padded>{children}</NewModalBodyWrapper>
        </ModalWrapper>
    );
};
